













 
















const node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isEditing"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "meetingId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "promptId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "isEditing",
        "variableName": "isEditing"
      },
      {
        "kind": "Variable",
        "name": "meetingId",
        "variableName": "meetingId"
      },
      {
        "kind": "Variable",
        "name": "promptId",
        "variableName": "promptId"
      }
    ],
    "concreteType": "EditReflectionPayload",
    "kind": "LinkedField",
    "name": "editReflection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "editorId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isEditing",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "promptId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditReflectionMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditReflectionMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": "m_uWvoXSwVNVy0YsZfFQWIZA",
    "metadata": {},
    "name": "EditReflectionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "ba3bffe6899f43d1618ee6ccdd78ab92";

export default node;
